export default function buildRemoveFilterParam({
    apiEndpoint,
    apiTools
}) {
    return async function removeFilterParam(args) {
        const url = apiTools.resolveUrl({
            ...args,
            apiEndpoint: `${ apiEndpoint }/param` 
        })
       
        const res = await fetch(url, {
            method: 'DELETE',
            headers: {
                'Content-type': 'application/json'
            },
            credentials: 'include',
        });
        return await res.json();
    }
}